export const forgotApiErrors: Record<string, string> = {
  invalid_email: 'Uh-oh. Email doesn\'t look valid.',
  request_is_already_processing: 'request_is_already_processing',
  invalid_request_body: 'invalid_request_body',
  invalid_device_id: 'invalid_device_id',
  undefined_error: 'undefined_error',
  invalid_verification_code: 'Looks like this reset link’s expired. Want a new one?',
};
